import styled from 'styled-components';
import { useAppContext } from '@adecco/base-app/src/utilities/appProvider/appProvider';
import Container from '@adecco/base-app/src/components/atoms/Container/Container';
import Button from '@adecco/base-app/src/components/atoms/Button/Button';
import Headline from '@adecco/base-app/src/components/atoms/Headline/Headline';
import Paragraph from '@adecco/base-app/src/components/atoms/Paragraph/Paragraph';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';

export type ICallToAction = {
  headline: string;
  subline?: string;
  link?: string;
  buttonText?: string;
};

const Wrapper = styled.div`
  border: ${(props) =>
    props.theme.brandColor
      ? `1px solid ${props.theme.brandColor}`
      : props.theme.borders.callToAction};
  padding: 24px;
  border-radius: 10px;
  display: grid;
  gap: 24px;
  box-shadow: ${(props) => props.theme.brandColor ? `0 5px 15px 0px ${props.theme.brandColor}26` : props.theme.boxShadow.callToAction};
  margin: 0 auto;
  width: 800px;
  max-width: 100%;
  background-color: white;

  ${moreThan('md')} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const HeadlineStyled = styled(Headline)`
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
`;

const ButtonStyled = styled(Button)`
  width: 100%;
`;

const CallToAction: React.FunctionComponent<ICallToAction> = ({
  headline,
  subline,
  link,
  buttonText,
}) => {
  const { t } = useAppContext();

  const handleClick = () => {
    if (!link?.trim() && typeof window !== undefined) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <Container>
      <Wrapper>
        <div>
          <HeadlineStyled skin={2} tag="h3">
            {headline}
          </HeadlineStyled>
          {subline && <Paragraph>{subline}</Paragraph>}
        </div>
        <div>
          <ButtonStyled
            variant="primary"
            onClick={handleClick}
            href={link?.trim() ? link : undefined}
            newTab
          >
            {buttonText || t('call-to-action-button')}
          </ButtonStyled>
        </div>
      </Wrapper>
    </Container>
  );
};

export default CallToAction;
